export enum MatchStatusType {
  NOT_STARTED = 'not_started',
  FINISHED = 'finished',
  CANCELED = 'canceled',
  POSTPONED = 'postponed',
  RUNNING = 'running',
}

export enum MatchStatusText {
  not_started = 'Not started',
  finished = 'Finished',
  canceled = 'Canceled',
  postponed = 'Postponed',
  running = 'Running',
}
